import { getLicensingStatus, getSystemFlags } from 'core/core.selectors';
import { verifyNemadigitalConfigAvailability } from 'pages/nemadigital/nemadigital.selectors';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { lazyRoute } from './lazy-route';

const NemaDigitalMapViewContainer = lazyRoute(() => import('pages/nemadigital/map-view/nemadigital-map-view.container'));

const NemaDigitalMapView = () => {
  const systemFlags = useSelector(getSystemFlags);
  const licensingStatus = useSelector(getLicensingStatus);
  const hasAccess = useSelector(verifyNemadigitalConfigAvailability);

  if (!systemFlags || !licensingStatus) {
    return null;
  }

  if (!hasAccess) {
    return <Navigate to='/hall-of-companies' />;
  }

  return <NemaDigitalMapViewContainer />;
};

export default NemaDigitalMapView;
